module.exports = __webpack_public_path__ + "img/admin-logo-white.0710e671.png";